import React, {Component} from 'react'
import querystring from 'query-string'
import {connect} from 'react-redux'

import {
    clearItems,
    filterCategory,
    filterVisibility,
    receiveItems,
    searchKeyword
} from '../../../actions/contents/post';
import {parseListParams} from './PostListHelper';
import {jsonResponseHandler} from '../../../utils/FetchHelper'
import LoadErrorBox from "../../../components/common/LoadErrorBox";
import * as InitStatus from '../../../constants/common/InitializationStatus';
import LoadingBox from "../../common/LoadingBox";
import PostListItem from "./PostListItem";
import { addPrefix } from '../../../utils/UriUtil';

@connect(state => ({
    items: state.post.item.items,
    totalCount: state.post.item.totalCount,
    condition: state.post.condition,
}), dispatch => ({
    handleReceivePosts: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    handleSearch: (keyword, type) => {
        dispatch(searchKeyword(keyword, type))
    },
    handleVisibility: (visibility) => {
        dispatch(filterVisibility(visibility))
    },
    handleFilterCategory: (categoryId) => {
        dispatch(filterCategory(categoryId))
    },
    handleClearItems: () => {
        dispatch(clearItems())
    },
    dispatch
}))
class PostList extends Component {

    constructor(props, context) {
        super(props, context);

        let listParams = parseListParams(props.location.search)

        this.state = {
            initialized: InitStatus.INIT_READY,
            currentPage: listParams.page,
            currentCategory: listParams.category,
            currentVisibility: listParams.visibility,
            currentSearchKeyword: listParams.searchKeyword,
            currentSearchType: listParams.searchType,
        }
        this.init = this.init.bind(this);
        this.fetchPosts = this.fetchPosts.bind(this);
    }

    componentDidMount() {
        this.init();
    }

    componentWillReceiveProps(nextProps) {

        const {currentPage, currentCategory, currentVisibility, currentSearchKeyword, currentSearchType} = this.state;
        let listParams = parseListParams(nextProps.location.search);

        if (currentPage !== listParams.page
            ||
            currentCategory !== listParams.category
            ||
            currentVisibility !== listParams.visibility
            ||
            currentSearchKeyword !== listParams.searchKeyword
            ||
            currentSearchType !== listParams.searchType
        ) {
            this.fetchPosts(listParams.page, listParams.category, listParams.visibility, listParams.searchKeyword, listParams.searchType);
            this.setState({
                currentPage: listParams.page,
                currentCategory: listParams.category,
                currentVisibility: listParams.visibility,
                currentSearchKeyword: listParams.searchKeyword,
                currentSearchType: listParams.searchType,
            });
        }

    }

    init() {
        const {currentPage, currentCategory, currentVisibility, currentSearchKeyword, currentSearchType} = this.state;

        const {dispatch} = this.props;

        this.setState({
            initialized: InitStatus.INIT_DOING,
        });

        fetch(addPrefix("/manage/posts.json?") + querystring.stringify({
            page: currentPage,
            category: currentCategory,
            visibility: currentVisibility,
            searchKeyword: currentSearchKeyword,
            searchType: currentSearchType
        }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceivePosts(data.items, data.totalCount);
                this.props.handleVisibility(currentVisibility);
                this.props.handleSearch(currentSearchKeyword, currentSearchType);
                this.props.handleFilterCategory(parseInt(currentCategory));
                this.setState({
                    initialized: InitStatus.INIT_SUCCESS,
                })
            })
            .catch(e => {
                console.error(e);
                this.props.handleReceivePosts([], 0);
                this.setState({
                    initialized: InitStatus.INIT_FAIL,
                })
            })

    }

    componentWillUnmount() {
        this.props.handleClearItems();
    }

    fetchPosts(page, category, visibility, searchKeyword, searchType) {

        const {dispatch} = this.props;

        fetch(addPrefix("/manage/posts.json?") + querystring.stringify({
            page: page,
            category: category,
            visibility: visibility,
            searchKeyword: searchKeyword,
            searchType: searchType
        }), {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceivePosts(data.items, data.totalCount);
                this.props.handleVisibility(visibility);
                this.props.handleSearch(searchKeyword, searchType);
                this.props.handleFilterCategory(parseInt(category));
            })
            .catch(e => {
                console.error(e);
                this.props.handleReceivePosts([], 0);
            })
    }

    render() {
        const {items} = this.props;

        return (
            <div className="wrap_list">
                <ul className="list_post list_post_type2">
                    {this.renderItems(items)}
                </ul>
            </div>
        )
    }

    renderEmptyItems() {

        const {condition, totalCount} = this.props;
        const {searchKeyword, category, visibility} = condition;

        const haveZeroPost = (searchKeyword === '' && (category === -3) && visibility === 'all');
        const tooManyPostMatched = (totalCount === -1);
        const emptyPostMatchedAtFilter = (searchKeyword === '' && (category !== -3 || visibility !== 'all'));

        if (haveZeroPost) {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                    아직 등록된 글이 없습니다.
                </div>
                <a href={addPrefix(`/manage/newpost/?type=post&returnURL=${location.pathname}`)} className="link_none">새 글 쓰기</a>
            </li>
        } else if (tooManyPostMatched) {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    검색 결과가 너무 많습니다. <br/>
                    구체적인 단어로 다시 검색해보세요.
                </div>
            </li>
        } else if (emptyPostMatchedAtFilter) {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    해당하는 글이 없습니다.
                </div>
            </li>
        } else {
            return <li className="info_none">
                <div className="txt_none">
                    <span className="wrap_ico"><span className="ico_blog ico_search"/></span>
                    검색 결과가 없습니다.
                </div>
            </li>
        }

    }

    renderItems(items) {
        const {initialized} = this.state;

        if (initialized === InitStatus.INIT_DOING) {
            return (<li className="info_none">
                <LoadingBox/>
            </li>);
        } else if (initialized === InitStatus.INIT_FAIL) {
            return (
                <LoadErrorBox retry={this.init}/>
            );
        } else if (initialized === InitStatus.INIT_SUCCESS) {
            if (items.length === 0) {
                return this.renderEmptyItems();
            } else {
                return items.map(item =>
                    <PostListItem key={item.id} item={item} listItemType="post"/>
                )
            }
        }
    }
}

export default PostList;

